import React, { useEffect, useState, useRef } from "react";
import ProfileImageAnonymus from "../assets/profile-elev.webp";
import {
  Image,
  Button,
  Descriptions,
  Divider,
  Tag,
  Input,
  Tabs,
  Table,
  Popconfirm,
} from "antd";
import { Accordion, Icon, Label } from "semantic-ui-react";
import CatalogElev from "../Pages/Elevi/CatalogElev";
import { DeleteOutlined } from "@ant-design/icons";
import ModalStergere from "./ModalStergere";
import ModalChangePassword from "./ModalSchimbareParola";
import ModalSelectEmail from "./ModalSelectEmail";
import { Select } from "antd";
import { useParams } from "react-router-dom";
import Comentarii from "./Comentarii";
import { useNavigate } from "react-router-dom";
import { calculare_medii } from "../utils/calculare_medie";
import { useReactToPrint } from "react-to-print";
import { RollbackOutlined } from "@ant-design/icons";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import { saveAs } from "file-saver";
// import template from "./instiintare parinti 2024 completat.docx";

import {
  useWindowSize,
  useWindowWidth,
  useWindowHeight,
} from "@react-hook/window-size";
import Docs from "./Docs";
import {
  AppstoreOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { testSlice } from "../redux/store";
import { Menu } from "antd";
import { listAll, getDownloadURL, ref } from "firebase/storage";
import { useSelector } from "react-redux";
import { storage } from "../database/firebase";
import { deleteDataDoc } from "../database";
import { getDataDoc, updateDocDatabase, uploadFileDatabse } from "../database";
import ModalViewGrade from "./ModalViewGrade";
import "./ElevPage.css";
import { openErrorNotification } from "./Notifications/errorNotification";
import OrarElev from "./OrarElev";
import "./ProfesorPage.css";
import EditElev from "./EditElev";
import { limit } from "firebase/firestore";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../database/firebase";
import templateCorigenta from "./instiintare parinti corigenti completat.docx";
import { motiveazaAbsente } from "../utils/absente";
import withErrorBoundary from "./withErrorComponent";
import { ciclu } from "../utils";
const { actions } = testSlice;

const { GET_LOADING } = actions;
const { TextArea } = Input;

const colors = [
  "magenta",
  "red",
  "volcano",
  "orange",
  "gold",
  "lime",
  "green",
  "cyan",
  "blue",
  "geekblue",
  "purple",
];
function ElevPage() {
  const { id } = useParams();
  const [elevData, setElevData] = useState({});
  const clase = useSelector((state) => state.clase);
  const [note, setNote] = useState([]);
  const [current, setCurrent] = useState("mail");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reff = useRef();
  const [tabKey, setTabKey] = useState("Note");
  const [author, setAuthor] = useState("");
  const [classData, setClassData] = useState([]);
  const [eleviData, setEleviData] = useState([]);
  const settings = useSelector((state) => state.settings);
  const [idOfElev, setIdOfElev] = useState("");
  const [mode, setMode] = useState("view");
  const [detailedInfoActive, setDetailedInfoActive] = useState(false);
  const user = useSelector((state) => state.user);
  const [modalStergere, setModalStergere] = useState(false);
  const [modalSchimbareParola, setModalSchimbaParola] = useState(false);
  const [modalSelectEmail, setModalSelectEmail] = useState(false);
  const [emailToChange, setEmailToChange] = useState("");

  const [open, setOpen] = useState(false);
  const [gradesElevi, setGradesElevi] = useState([]);
  const [elevId, setElevId] = useState();
  const profesori = useSelector((state) => state.profesori);
  const [scutiri, setScutiri] = useState([]);
  const [docsElev, setDocsElev] = useState([]);
  const [permision, setPermision] = useState(false);
  const [notePrint, setNotePrint] = useState([]);
  const [elevId2, setElevId2] = useState();
  const onlyWidth = useWindowWidth();
  const [materieId, setMaterieId] = useState();
  const [nota, setNota] = useState();
  const [comentariu, setComentariu] = useState();
  const [data, setData] = useState();
  const [tip, setTip] = useState();
  const [open2, setOpen2] = useState(false);
  const [absenteConcluzii, setAbsenteConcluzii] = useState([]);
  const Limit = 40;

  const onClick = (e) => {
    setCurrent(e.key);
  };

  const formatDate = (today) => {
    const romaniaTime = new Date(
      today.toLocaleString("en-US", { timeZone: "Europe/Bucharest" })
    );

    const yyyy = romaniaTime.getFullYear();
    let mm = romaniaTime.getMonth() + 1; // Months start at 0!
    let dd = romaniaTime.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    return dd + "/" + mm;
  };

  const fetchData = async () => {
    let data = await getDataDoc("elevi", id);
    if (data) setElevData({ ...data, id });
    if (!data) return;
    const not = await getDataDoc("catalog", id);

    let dataClass = await getDataDoc("claseData", data?.clasa || "faraclasa");

    // Verifică dacă profesorul are acces la acest elev
    let areAcces = false;

    // Verifică în materiile normale ale clasei
    if (
      dataClass?.materii?.find((m) => m.profesori?.find((p) => p === user.uid))
    ) {
      areAcces = true;
    }

    // Verifică în materiile specializate ale elevului
    if (!areAcces && data?.materiiSpecialitate) {
      const areMaterieCuProfesor = data.materiiSpecialitate.some((ms) =>
        (ms?.profesori || []).includes(user.uid)
      );
      if (areMaterieCuProfesor) {
        areAcces = true;
      }
    }

    // Verifică dacă este diriginte
    if (
      !areAcces &&
      (dataClass?.diriginte == user.uid ||
        dataClass?.diriginte_step == user.uid)
    ) {
      areAcces = true;
    }

    // Verifică dacă este admin
    if (!areAcces && user.type === "admin") {
      areAcces = true;
    }

    if (
      user.uid &&
      !areAcces &&
      user.type !== "admin" &&
      data?.clasa !== "faraclasa" &&
      data?.clasa
    )
      navigate("/");
    if (data.deleted === true) {
      dataClass = await getDataDoc(
        "claseData",
        data?.clasaVeche || "faraclasa"
      );
    }

    const docs = await getDataDoc("eleviDocumente", id);
    let scutiriElevi = [];
    setScutiri(docs?.docsElev);
    let obj = {};

    let perm = false;
    if (
      user.uid === dataClass?.diriginte ||
      user.uid === dataClass?.diriginte_step ||
      user.type === "admin"
    )
      perm = true;

    dataClass?.materii?.forEach((materieId) => {
      if (perm === false) {
        if (
          dataClass?.materii
            ?.filter((ma) => ma?.profesori?.find((p) => p === user.id))
            .find((m) => m.materie === materieId.materie)
        )
          obj[materieId.materie] = { note: [] };
      } else obj[materieId.materie] = { note: [] };
    });
    not?.note?.forEach((n) => {
      if (obj[n.materieId]?.note) obj[n.materieId]?.note?.push(n);
    });
    setNote(Object.entries(obj));
    if (perm === true)
      setClassData({
        ...dataClass,
        ore: (dataClass?.ore || []).map((el) => {
          return {
            ...el,
            startDate: new Date(el.startDate),
            endDate: new Date(el.endDate),
          };
        }),
      });
    else {
      setClassData({
        ...dataClass,
        ore: (dataClass?.ore || []).map((el) => {
          return {
            ...el,
            startDate: new Date(el.startDate),
            endDate: new Date(el.endDate),
          };
        }),
        materii: dataClass?.materii?.filter((ma) =>
          ma?.profesori?.find((p) => p === user.id)
        ),
      });
    }
    setPermision(perm);
    const NotePrint = [];
    NotePrint.push({
      notes: Object.entries(obj),
      name: data.numeDeFamilie + " " + data.initiala + " " + data.prenume,
      id: data.id,
    });
    setNotePrint(NotePrint);
  };

  const materii = useSelector((state) => state.materii);
  const styleD = () => {
    if (onlyWidth < 700) return "auto";
    if (onlyWidth < 1000) return "auto auto auto ";
    if (onlyWidth < 1200) return "auto auto auto auto";
    return "auto auto auto auto auto";
  };
  useEffect(() => {
    const unsub = onSnapshot(doc(db, "eleviDocumente", id), (doc) => {
      const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
      setDocsElev(doc.data()?.docsElev);
    });
    return unsub;
  }, []);
  useEffect(() => {
    const absente = [];

    const noteDeschis = note?.reduce((acc, c) => {
      return [...acc, ...c[1].note];
    }, []);
    setAbsenteConcluzii(motiveazaAbsente(noteDeschis, scutiri));
  }, [note, scutiri]);

  useEffect(() => {
    fetchData();
  }, [id]);
  const onChange = (key) => {
    setTabKey(key);
  };

  const RaportScolar = () => {
    return (
      <div className="print" ref={reff}>
        <div className="print-header">
          <div className="print-logo">
            <img
              src={process.env.REACT_APP_LOGO}
              alt="Logo Instituție"
              className="logo-print"
            />
          </div>
          <div className="print-header-text">
            <h1 style={{ textAlign: "center", margin: "10px 0" }}>
              Situație școlară
            </h1>
            <h4 style={{ textAlign: "center", margin: "5px 0" }}>
              Instituție școlară: {settings?.numeInstitutie}
            </h4>
          </div>
        </div>
        <div className="print-content">
          <div className="student-info">
            <h2
              style={{
                textAlign: "center",
                margin: "15px 0",
                fontSize: "24px",
                fontWeight: "bold",
              }}
            >
              {elevData.numeDeFamilie +
                " " +
                elevData.initiala +
                " " +
                elevData.prenume}
            </h2>
            <h3
              style={{
                textAlign: "center",
                margin: "10px 0",
                fontSize: "18px",
              }}
            >
              Clasa {classData.anClasa} {classData.identificator}
            </h3>
          </div>

          <div className="document-info">
            <p style={{ textAlign: "center", margin: "8px 0" }}>
              <strong>Anul școlar 2025-2026</strong>
            </p>
            <p style={{ textAlign: "center", margin: "5px 0" }}>
              <strong>Diriginte/Învățător:</strong>{" "}
              {profesori?.find((p) => p.id === classData?.diriginte)
                ?.numeDeFamilie +
                " " +
                profesori?.find((p) => p.id === classData?.diriginte)?.prenume}
            </p>
            {classData?.diriginte_step &&
              classData?.diriginte_step !== "N/A" && (
                <p style={{ textAlign: "center", margin: "5px 0" }}>
                  <strong>Alături de:</strong>{" "}
                  {profesori?.find((p) => p.id === classData?.diriginte_step)
                    ?.numeDeFamilie +
                    " " +
                    profesori?.find((p) => p.id === classData?.diriginte_step)
                      ?.prenume}
                </p>
              )}
            <p
              style={{
                textAlign: "center",
                margin: "10px 0",
                fontSize: "12px",
                color: "#666",
              }}
            >
              Export realizat din Catalogul electronic LUNA
              <br />
              CUI: 46952301
            </p>
          </div>
          <div className="subjects-section">
            <h4
              style={{
                marginTop: "20px",
                marginBottom: "10px",
                textAlign: "left",
              }}
            >
              Materii înscrise în catalog
            </h4>
            <table
              className="subjects-table"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #000",
              }}
            >
              <thead>
                <tr>
                  <th>Materie</th>
                  <th>Profesori</th>
                </tr>
              </thead>
              <tbody>
                {classData?.materii?.map((m) => {
                  return (
                    <tr
                      className="subject-row"
                      style={{
                        pageBreakInside: "avoid",
                        pageBreakAfter: "auto",
                        border: "1px solid #000",
                      }}
                    >
                      <td style={{ padding: "8px", border: "1px solid #000" }}>
                        <strong>
                          {
                            materii?.find((ma) => ma.id === m.materie)
                              ?.numeMaterie
                          }
                        </strong>
                      </td>
                      <td style={{ padding: "8px", border: "1px solid #000" }}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "5px",
                            pageBreakInside: "avoid",
                            pageBreakAfter: "auto",
                          }}
                        >
                          {m?.profesori?.map((idp, index) => (
                            <span key={idp}>
                              {profesori?.find((p) => p.id === idp)
                                ?.numeDeFamilie +
                                " " +
                                profesori?.find((p) => p.id === idp)?.prenume}
                              {index < m.profesori.length - 1 && ", "}
                            </span>
                          ))}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="catalog-section" style={{ pageBreakBefore: "always" }}>
          <div className="print-header">
            <div className="print-logo">
              <img
                src={process.env.REACT_APP_LOGO}
                alt="Logo Instituție"
                className="logo-print"
              />
            </div>
            <div className="print-header-text">
              <h1 style={{ textAlign: "center", margin: "10px 0" }}>
                Catalog - {elevData.numeDeFamilie} {elevData.initiala}{" "}
                {elevData.prenume}
              </h1>
            </div>
          </div>
          <CatalogElev elevIdPassed={id} />
        </div>

        <div
          className="exemptions-section"
          style={{ pageBreakBefore: "always" }}
        >
          <div className="print-header">
            <div className="print-logo">
              <img
                src={process.env.REACT_APP_LOGO}
                alt="Logo Instituție"
                className="logo-print"
              />
            </div>
            <div className="print-header-text">
              <h1 style={{ textAlign: "center", margin: "10px 0" }}>
                Scutiri - {elevData.numeDeFamilie} {elevData.initiala}{" "}
                {elevData.prenume}
              </h1>
            </div>
          </div>
          <Docs
            elevId={id}
            numeElev={elevData.prenume + " " + elevData.numeDeFamilie}
            classId={elevData?.clasa}
            modeOf={"view"}
            elevData={elevData}
            openAll={true}
          />
        </div>
      </div>
    );
  };
  const handlePrint = useReactToPrint({
    content: () => reff.current,
  });
  async function generateDocument(resume, templatePath) {
    try {
      let response = await fetch(templatePath);

      let data = await response.arrayBuffer();

      let zip = PizZip(data);
      let templateDoc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      templateDoc.render(resume);
      let generatedDoc = templateDoc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        compression: "DEFLATE",
      });

      saveAs(generatedDoc, `${resume.nume}, adeverinta absente.docx`);
    } catch (error) {}
  }

  return (
    <div>
      {" "}
      <ModalSelectEmail
        open={modalSelectEmail}
        setOpen={setModalSelectEmail}
        emails={[
          ...(elevData?.adresaEmail ? [elevData.adresaEmail] : []),
          ...(elevData?.parintii || []),
        ]}
        onEmailSelected={(selectedEmail) => {
          setEmailToChange(selectedEmail);
          setModalSchimbaParola(true);
        }}
      />
      <ModalChangePassword
        open={modalSchimbareParola}
        email={emailToChange}
        setOpen={setModalSchimbaParola}
        id={idOfElev}
        setId={setIdOfElev}
      />
      <ModalStergere
        open={modalStergere}
        setOpen={setModalStergere}
        elevData={{ ...elevData }}
      />
      <div style={{ display: "none" }}>
        <RaportScolar />
      </div>
      <ModalViewGrade
        open={open2}
        edit={false}
        setOpen={setOpen2}
        eleviData={[{ ...elevData, id }]}
        elevId={id}
        gradesElevi={gradesElevi}
        setElevId={setElevId}
        materii={classData.materii?.map((matID) => {
          return materii?.find((ma) => ma.id === matID.materie);
        })}
        author={author}
        setGradesElevi={setGradesElevi}
        materieId={materieId}
        tip={tip}
        nota={nota}
        comentariu={comentariu}
        date={data}
        scutiri={scutiri}
      />
      <div className="mode-view">
        {elevData?.deleted === true && (
          <h1 style={{ color: "red" }}>
            ELEV transferat, clasa veche{" "}
            {clase?.find((cls) => cls.id === elevData.clasaVeche)?.anClasa +
              " " +
              clase?.find((cls) => cls.id === elevData.clasaVeche)
                ?.identificator}
          </h1>
        )}

        <div className="elev-page-content">
          <div>
            {mode === "view" ? (
              <>
                {/* Basic Info Section */}
                <div className="elev-basic-info">
                  <h2 className="elev-name">
                    {elevData.numeDeFamilie} {elevData.initiala}{" "}
                    {elevData.prenume}
                    {elevData.retras && (
                      <Tag color="red" style={{ marginLeft: 8 }}>
                        Transferat
                      </Tag>
                    )}
                  </h2>
                  <div className="elev-class">
                    <Tag color="blue" size="large">
                      Clasa{" "}
                      {clase?.find((cls) => cls.id === elevData.clasa)
                        ?.anClasa || "-"}{" "}
                      {clase?.find((cls) => cls.id === elevData.clasa)
                        ?.identificator || "-"}
                    </Tag>
                  </div>
                  {elevData?.adresaEmail &&
                    !elevData?.adresaEmail.includes("dobriceansoftware") && (
                      <div className="elev-email">
                        <strong>Email:</strong> {elevData?.adresaEmail}
                      </div>
                    )}
                  {elevData.parintii &&
                    elevData.parintii.filter(
                      (email) => !email.includes("dobriceansoftware")
                    ).length > 0 && (
                      <div className="elev-subscribed-emails">
                        <strong>Emailuri abonate:</strong>{" "}
                        {elevData.parintii
                          .filter(
                            (email) => !email.includes("dobriceansoftware")
                          )
                          .join(", ")}
                      </div>
                    )}
                  <div className="elev-absente">
                    <strong>Absențe bilet rămase:</strong>{" "}
                    {absenteConcluzii.absenteBiletRamase}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="elev-actions">
                  {(() => {
                    const canDelete =
                      user.type === "admin" && elevData?.deleted !== true;
                    const canEdit =
                      user.type === "admin" ||
                      user.uid === classData?.diriginte ||
                      user.uid === classData?.diriginte_step ||
                      elevData.clasa === "faraclasa";
                    const actions = [];

                    if (canDelete && window.innerWidth > 768) {
                      actions.push(
                        <Popconfirm
                          key="delete"
                          title="Ștergi Elevul?"
                          onConfirm={async () => {
                            setModalStergere(true);
                          }}
                          onCancel={() => {}}
                        >
                          <Button
                            shape="circle"
                            icon={<DeleteOutlined />}
                            danger
                          />
                        </Popconfirm>
                      );
                    }

                    if (canEdit) {
                      // Creăm o listă cu toate emailurile disponibile
                      const availableEmails = [
                        ...(elevData?.adresaEmail
                          ? [elevData.adresaEmail]
                          : []),
                        ...(elevData?.parintii || []),
                      ].filter((email) => !email.includes("dobriceansoftware"));

                      // Afișează butonul "Schimba Parola" doar dacă există emailuri disponibile
                      if (availableEmails.length > 0) {
                        actions.push(
                          <Button
                            key="password"
                            onClick={() => {
                              if (availableEmails.length === 1) {
                                // Dacă există doar un email, îl selectez direct
                                setEmailToChange(availableEmails[0]);
                                setModalSchimbaParola(true);
                              } else {
                                // Dacă există mai multe emailuri, afișez modalul de selecție
                                setModalSelectEmail(true);
                              }
                            }}
                          >
                            Schimba Parola
                          </Button>
                        );
                      }
                      actions.push(
                        <Button
                          key="edit"
                          type="primary"
                          onClick={() => {
                            setMode("edit");
                          }}
                        >
                          Edit
                        </Button>
                      );
                    }

                    return actions;
                  })()}
                </div>

                {/* Detailed Info Accordion */}
                <Accordion styled fluid>
                  <Accordion.Title
                    active={detailedInfoActive}
                    index={0}
                    onClick={() => setDetailedInfoActive(!detailedInfoActive)}
                  >
                    <Icon name="dropdown" />
                    Informații detaliate
                  </Accordion.Title>
                  <Accordion.Content active={detailedInfoActive}>
                    <Descriptions
                      layout={onlyWidth < 900 ? "vertical" : "horizontal"}
                      column={onlyWidth < 900 ? 1 : 2}
                      bordered
                      size="small"
                      extra={(() => {
                        // Verificare pentru ștergere (doar admin și elevul nu este șters)
                        const canDelete =
                          user.type === "admin" && elevData?.deleted !== true;

                        // Verificare pentru editare (admin sau diriginte)
                        const canEdit =
                          user.type === "admin" ||
                          user.uid === classData?.diriginte ||
                          user.uid === classData?.diriginte_step ||
                          elevData.clasa === "faraclasa";

                        const actions = [];

                        // Adăugare buton de ștergere dacă are permisiuni
                        if (canDelete) {
                          actions.push(
                            <Popconfirm
                              title="Ștergi Elevul?"
                              onConfirm={async () => {
                                setModalStergere(true);
                              }}
                              onCancel={() => {}}
                            >
                              <Button
                                shape="circle"
                                icon={<DeleteOutlined />}
                                style={{ marginRight: "10px" }}
                              />
                            </Popconfirm>
                          );
                        }

                        // Adăugare buton de editare dacă are permisiuni
                        if (canEdit) {
                          // Creăm o listă cu toate emailurile disponibile pentru modalul din accordion
                          const availableEmailsAccordion = [
                            ...(elevData?.adresaEmail
                              ? [elevData.adresaEmail]
                              : []),
                            ...(elevData?.parintii || []),
                          ].filter(
                            (email) => !email.includes("dobriceansoftware")
                          );

                          if (availableEmailsAccordion.length > 0) {
                            actions.push(
                              <Button
                                color="default"
                                variant="outlined"
                                style={{ margin: "2px" }}
                                onClick={() => {
                                  if (availableEmailsAccordion.length === 1) {
                                    // Dacă există doar un email, îl selectez direct
                                    setEmailToChange(
                                      availableEmailsAccordion[0]
                                    );
                                    setModalSchimbaParola(true);
                                  } else {
                                    // Dacă există mai multe emailuri, afișez modalul de selecție
                                    setModalSelectEmail(true);
                                  }
                                }}
                              >
                                Schimba Parola
                              </Button>
                            );
                          }
                          actions.push(
                            <Button
                              type="primary"
                              onClick={() => {
                                setMode("edit");
                              }}
                            >
                              Edit
                            </Button>
                          );
                        }

                        return actions;
                      })()}
                    >
                      <Descriptions.Item label="Nume">
                        {elevData.numeDeFamilie}
                      </Descriptions.Item>
                      <Descriptions.Item label="Prenume">
                        {elevData.prenume}
                      </Descriptions.Item>

                      <Descriptions.Item label="Initiala">
                        {elevData.initiala}
                      </Descriptions.Item>

                      <Descriptions.Item label="Clase">
                        {(clase?.find((cls) => cls.id === elevData.clasa)
                          ?.anClasa || "-") +
                          " " +
                          (clase?.find((cls) => cls.id === elevData.clasa)
                            ?.identificator || "-")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Abs. ramase Bilet">
                        {absenteConcluzii.absenteBiletRamase}
                      </Descriptions.Item>

                      <Descriptions.Item
                        label="Nr. Matricol"
                        style={{
                          border: !elevData.numarMatricol?.trim()
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {elevData.numarMatricol}
                      </Descriptions.Item>

                      <Descriptions.Item
                        label="Nr. Telefon"
                        style={{
                          border: !elevData.numarTelefon?.trim()
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {elevData.numarTelefon}
                      </Descriptions.Item>
                      {elevData?.adresaEmail &&
                        !elevData?.adresaEmail.includes(
                          "dobriceansoftware"
                        ) && (
                          <Descriptions.Item label="Email">
                            {elevData?.adresaEmail}
                          </Descriptions.Item>
                        )}

                      <Descriptions.Item label="CNP">
                        {elevData.cnp}
                      </Descriptions.Item>
                      {elevData?.loculNasteri && (
                        <Descriptions.Item label="Locul Nasterii">
                          {elevData.loculNasteri}
                        </Descriptions.Item>
                      )}
                      {elevData.premiu && (
                        <Descriptions.Item label="Premiu">
                          {elevData.premiu}
                        </Descriptions.Item>
                      )}

                      <Descriptions.Item
                        label="Domiciliu"
                        style={{
                          border: !elevData.domiciliu?.trim()
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {elevData.domiciliu}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Prenume mamă"
                        style={{
                          border: !elevData.mama?.trim()
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {elevData.mama}
                      </Descriptions.Item>
                      <Descriptions.Item
                        label="Prenume tată"
                        style={{
                          border: !elevData.mama?.trim()
                            ? "1px solid red"
                            : "none",
                        }}
                      >
                        {elevData.tata}
                      </Descriptions.Item>
                      {elevData.scutitMedical && (
                        <Descriptions.Item label="Cerere Scutire Medicală">
                          {elevData.scutitMedical}
                        </Descriptions.Item>
                      )}
                      {elevData.dataExpirareMedical && (
                        <Descriptions.Item label="Data Expirare Medical">
                          {elevData.dataExpirareMedical
                            ? new Date(
                                elevData.dataExpirareMedical
                              ).toLocaleDateString("ro-RO")
                            : "-"}
                        </Descriptions.Item>
                      )}

                      {elevData.religie && elevData.religie !== "da" && (
                        <Descriptions.Item label="Cerere retragere Religie">
                          {elevData.religie}
                        </Descriptions.Item>
                      )}

                      {elevData.religie &&
                        elevData.religie !== "da" &&
                        elevData.cerereReligie && (
                          <Descriptions.Item label="Detalii Cerere Religie">
                            {elevData.cerereReligie}
                          </Descriptions.Item>
                        )}

                      <Descriptions.Item label="CES">
                        {elevData.ces === "da" ? "DA" : "NU"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Bursa">
                        {elevData.bursa}
                      </Descriptions.Item>
                      {process.env.REACT_APP_NAME === "LMTJ" && (
                        <Descriptions.Item label="Prof. Indr">
                          {elevData.profindr || ""}
                        </Descriptions.Item>
                      )}
                      {process.env.REACT_APP_NAME === "LMTJ" && (
                        <Descriptions.Item label="Ins. Prin.">
                          {elevData.insprin || ""}
                        </Descriptions.Item>
                      )}
                      {process.env.REACT_APP_NAME === "LMTJ" && (
                        <Descriptions.Item label="Ins. Sec.">
                          {elevData.inssec || ""}
                        </Descriptions.Item>
                      )}

                      <Descriptions.Item label="Email-uri abonate">
                        {(elevData?.parintii || [])
                          .filter((e) => !e.includes("dobriceansoftware"))
                          .map((e) => (
                            <Tag
                              onClick={() => {
                                const canEdit =
                                  user.type === "admin" ||
                                  user.uid === classData?.diriginte ||
                                  user.uid === classData?.diriginte_step;
                                if (canEdit) {
                                  // Pentru click pe un tag specific, selectez direct acel email
                                  setModalSchimbaParola(true);
                                  setIdOfElev(undefined);
                                  setEmailToChange(e);
                                }
                              }}
                            >
                              {e}
                            </Tag>
                          ))}
                      </Descriptions.Item>

                      {permision === true && (
                        <Descriptions.Item label="Documente">
                          <div>
                            <Button
                              type="primary"
                              onClick={() => {
                                handlePrint();
                              }}
                              style={{}}
                            >
                              Descarca Situatie Scolara
                            </Button>
                            {settings?.adeverintaAbsente && (
                              <Button
                                type="primary"
                                onClick={async () => {
                                  let url = settings.adeverintaAbsente;
                                  //fetch the url
                                  const clas = clase?.find(
                                    (c) => c.id === elevData.clasa
                                  );
                                  if (url) {
                                    generateDocument(
                                      {
                                        nume:
                                          elevData.numeDeFamilie +
                                          " " +
                                          elevData.initiala +
                                          " " +
                                          elevData.prenume,
                                        clasa:
                                          clas?.anClasa === "Pregătitoare" ||
                                          clas?.anClasa === "I"
                                            ? clas?.anClasa +
                                              " " +
                                              clas?.identificator
                                            : "a " +
                                              clas?.anClasa +
                                              "-a" +
                                              (clas?.identificator.length > 0 &&
                                              clas.identificator !== " "
                                                ? " " + clas?.identificator
                                                : ""),
                                        absente:
                                          absenteConcluzii.absente_dupa_motivari
                                            .length,
                                        motivate:
                                          absenteConcluzii.absente_motivate
                                            ?.length,
                                        nemotivate:
                                          absenteConcluzii.absente_nemotivate
                                            ?.length,
                                      },
                                      url
                                    );
                                  }
                                }}
                                style={{ marginTop: "5px" }}
                              >
                                Descarca Adeverinta absente
                              </Button>
                            )}
                            {settings?.adeverintaApartenenta && (
                              <Button
                                type="primary"
                                onClick={async () => {
                                  let url = settings.adeverintaApartenenta;
                                  //fetch the url
                                  const clas = clase?.find(
                                    (c) => c.id === elevData.clasa
                                  );
                                  if (url) {
                                    generateDocument(
                                      {
                                        nume:
                                          elevData.numeDeFamilie +
                                          " " +
                                          elevData.initiala +
                                          " " +
                                          elevData.prenume,
                                        cnp: elevData.cnp,
                                        detalii_profil:
                                          clas?.identificator === "A" &&
                                          ciclu(clas) === "liceu"
                                            ? "profil artistic, specializarea Muzică,"
                                            : clas?.identificator === "B" &&
                                              ciclu(clas) === "liceu"
                                            ? "profil pedagogic, specializarea Educator-Învățător,"
                                            : "",
                                        clasa:
                                          clas?.anClasa === "Pregătitoare" ||
                                          clas?.anClasa === "I"
                                            ? clas?.anClasa +
                                              " " +
                                              clas?.identificator
                                            : "a " +
                                              clas?.anClasa +
                                              "-a" +
                                              (clas?.identificator.length > 0 &&
                                              clas.identificator !== " "
                                                ? " " + clas?.identificator
                                                : ""),
                                        numarMatricol: elevData.numarMatricol,
                                      },
                                      url
                                    );
                                  }
                                }}
                                style={{ marginTop: "5px" }}
                              >
                                Descarca Adeverinta de apartanenta
                              </Button>
                            )}
                          </div>
                        </Descriptions.Item>
                      )}
                      {elevData.details && (
                        <Descriptions.Item label="Detalii catalog">
                          {elevData.details}
                        </Descriptions.Item>
                      )}

                      <Descriptions.Item label="Starea la încheierea cursurilor">
                        {elevData?.stareaLaIncheiereaCursurilor}
                      </Descriptions.Item>

                      <Descriptions.Item label="Starea la finalul anului școlar">
                        {elevData?.stareaLaFinalulAnului}
                      </Descriptions.Item>

                      <Descriptions.Item label="Materii specialitate">
                        <span>
                          {elevData?.materiiSpecialitate?.map(
                            (materie, index) => {
                              return (
                                <>
                                  <div
                                    style={{
                                      paddingTop: "20px",
                                      display: "block",
                                      gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <Select
                                      showSearch
                                      style={{ width: "90%" }}
                                      placeholder="Materie"
                                      optionFilterProp="children"
                                      value={materie.materie}
                                      disabled={true}
                                      filterOption={(input, option) =>
                                        (
                                          option?.label?.toLowerCase() ?? ""
                                        ).includes(input?.toLowerCase())
                                      }
                                      filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? "")
                                          .toLowerCase()
                                          .localeCompare(
                                            (optionB?.label ?? "").toLowerCase()
                                          )
                                      }
                                      options={materii.map((mat) => {
                                        return {
                                          label:
                                            mat?.numeMaterie +
                                            "-" +
                                            mat?.profil,
                                          value: mat?.id,
                                        };
                                      })}
                                    />
                                    <Select
                                      mode="multiple"
                                      style={{ width: "90%" }}
                                      showSearch
                                      placeholder="Profesor"
                                      disabled={true}
                                      optionFilterProp="children"
                                      value={materie.profesori}
                                      filterOption={(input, option) =>
                                        (
                                          option?.label?.toLowerCase() ?? ""
                                        ).includes(input?.toLowerCase())
                                      }
                                      filterSort={(optionA, optionB) =>
                                        (optionA?.label ?? "")
                                          .toLowerCase()
                                          .localeCompare(
                                            (optionB?.label ?? "").toLowerCase()
                                          )
                                      }
                                      options={(
                                        materii?.find(
                                          (mat) => mat.id === materie?.materie
                                        )?.profesori || []
                                      ).map((profID) => {
                                        let prof = profesori?.find(
                                          (pf) => pf.id === profID
                                        );
                                        return {
                                          label:
                                            prof?.numeDeFamilie +
                                            "-" +
                                            prof?.prenume,
                                          value: prof?.id,
                                        };
                                      })}
                                    />
                                  </div>
                                  <br />
                                </>
                              );
                            }
                          )}
                        </span>
                      </Descriptions.Item>
                    </Descriptions>
                  </Accordion.Content>
                </Accordion>
              </>
            ) : (
              <EditElev
                elevData={elevData}
                setMode={setMode}
                setElevData={setElevData}
                clase={clase}
                colors={colors}
                id={id}
              />
            )}
          </div>
        </div>
      </div>
      <br />
      <Divider style={{ borderBlockStart: "0px" }} />
      <Tabs
        tabBarStyle={{
          width: "100%",
          fontWeight: "bold",
          backgroundColor: "#f5f5f5",
        }}
        size="large"
        onChange={onChange}
        activeKey={tabKey}
        style={{}}
        items={[
          {
            label: `Note`,
            key: "Note",
            children: <CatalogElev elevIdPassed={id} />,
          },

          {
            label: `Comentarii`,
            key: "Comentarii",
            children: <Comentarii elevData={elevData} id={id} note={note} />,
          },

          permision === true
            ? {
                label: `Documente Școlare`,
                key: "docs",
                children: (
                  <Docs
                    elevId={id}
                    retras={elevData.retras}
                    classId={classData?.id}
                    numeElev={elevData.numeDeFamilie + " " + elevData.prenume}
                    elevData={elevData}
                  />
                ),
              }
            : {},
          user.type === "admin"
            ? {
                label: `Transferuri`,
                key: "transferuri",
                children: (
                  <Docs
                    elevId={id}
                    retras={elevData.retras}
                    classId={classData?.id}
                    numeElev={elevData.numeDeFamilie + " " + elevData.prenume}
                    elevData={elevData}
                    transferuri={true}
                  />
                ),
              }
            : {},
        ]}
      />
    </div>
  );
}

export default withErrorBoundary(ElevPage);
